import { createFileRoute } from '@tanstack/react-router'

import { GroupSubscriptionsPage } from '#/modules/loadboards/group-subscriptions-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/group-subscriptions')({
  component: GroupSubscriptionsPage,
  validateSearch: validateListSearch,
})
